<template>
  <div class="d-active" :class="{bottom: position === 'bottom'}">
    <div class="menu">
      <div class="m-item" @click.stop="callback(item)" v-for="(item, i) in list" :key="i">
        <!--        <div class="c">-->
        <span>{{ item }}</span>
        <!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {};
  },
  props: ['list', 'callback', 'position'],
  methods: {
    callFn(fnName, param) {
      this[fnName] && this[fnName].call(this, param)
    }
  },
};
</script>
<style scoped>
.bottom {
  align-items: flex-start;
  top: unset;
  bottom: -5px;
}

.m-item {
  padding: 3px 5px;
  height: 26px;
}

.m-item span:nth-child(1):not(.group), .m-item a:nth-child(1) {
  min-width: unset;
}

.d-active .menu {
  top: 0;
  position: static;
  width: auto;
  max-height: 200px;
  overflow-y: auto;
}
</style>